const languagesMenu = document.querySelectorAll(".languages");

if (languagesMenu) {
    languagesMenu.forEach((item) => {
        item.addEventListener("click", function () {
            item.classList.toggle("show");
        });
    });
}
